module.exports = __webpack_public_path__ + "static/media/terrain-mountain-01.0a0b9385.svg";